module.exports = __webpack_public_path__ + "Assets/icons/features/limit-view.svg";